<template>
  <div class="layout-404">
    <div class="container">
      <div class="w-500 title"><slot name="title"></slot></div>
      <div class="s-20 w-400"><slot name="subtitle"></slot></div>
      <!--  -->
      <div class="button-wrapper">
        <slot name="button"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    if (typeof (ym) === "function") {
      let yaCounterId = this.$store.state.langs.YACOUNTER;
      ym(yaCounterId, 'reachGoal', 'error404');
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-404 {
  text-align: center;
  padding: 7em 0;
}
.title {
  font-size: 7em;
}
.button-wrapper {
  margin-top: 6em;
}
</style>
